import { createAppSelector, pageSelectors, selectCurrentPageId } from "./base";

import type { RootState } from "store";

export const selectCurrentPage = createAppSelector(
  [selectCurrentPageId, pageSelectors.selectEntities],
  (pageId, pages) => (pageId && pageId in pages ? pages[pageId] : null),
);

export const selectWorksheetIdByPage = (state: RootState, pageId: string | null) =>
  pageSelectors.selectById(state, pageId)?.worksheet_id ?? null;

export const selectPageIdByWorksheetId = createAppSelector(
  [pageSelectors.selectAll, (state, worksheetId: string) => worksheetId],
  (pages, worksheetId) => {
    return pages.find((page) => page.worksheet_id === worksheetId)?.id ?? null;
  },
);
